"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTransformUrl = exports.buildProxyUrl = void 0;
const array_to_query_string_1 = __importDefault(require("./array_to_query_string"));
const hosts_1 = require("./hosts");
const version = '1';
const buildProxyUrl = url => {
  const encodedUrl = encodeURIComponent(url);
  return `https://${hosts_1.PROXY_HOST}/${version}/proxy?url=${encodedUrl}`;
};
exports.buildProxyUrl = buildProxyUrl;
const generateVersionFromUrl = url => {
  const downcaseUrl = url.toLowerCase();
  if (/(png|jpg|jpeg|webp)$/.exec(downcaseUrl)) return '1';
  if (downcaseUrl.endsWith('gif')) return '2';
  return '3';
};
const buildTransformUrl = (url, options) => {
  const processingOptionsString = options.transforms.map(x => x.join('_'));
  let version;
  const urlQueryParams = [];
  if (options.metadata) {
    urlQueryParams.push(['m', '1']);
    version = '1';
  } else {
    version = generateVersionFromUrl(url);
  }
  if (processingOptionsString.length > 0) urlQueryParams.push(['t', processingOptionsString.join(',')]);
  urlQueryParams.push(['url', url]);
  const urlQueryString = array_to_query_string_1.default(urlQueryParams);
  if (options.format) {
    return `https://${hosts_1.INHOUSE_HOST}/${version}/image.${options.format}?${urlQueryString}`;
  }
  return `https://${hosts_1.INHOUSE_HOST}/${version}/image?${urlQueryString}`;
};
exports.buildTransformUrl = buildTransformUrl;